export default __webpack_public_path__ + "static/media/firestore-dark.20219d49.png";